import { AUTH_TOKEN_KEY } from 'watchtower-ui/utils/Constants';

const clearStoredAuthToken = () => {
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
};

export default clearStoredAuthToken;
